<template>
    <div class="main-data-quickentry">
        <div v-if="this.mode===0" class="form-entry-list">
            <div class="form-entry-form" v-for="(item,index) in dataList" :key="index"  @click="jumpForm(item)">
                <img :src="gateway.mxbd_icon"  @click.stop="addFormVal(item)" v-if="setFormAuth(item)">
                <p :title="item.modelName">{{item.modelName}}</p>
           <!--     <span class="name">{{item.modelName}}</span> -->
            <!--    <i class="iconfont icon-other-xinzeng form-add"  @click.stop="addFormVal(item)" v-if="setFormAuth(item)"></i> -->
            </div>
        </div>
        <div v-if="this.mode===1" class="form-entry-list">
            <div class="approve-list">
<!--                <div class="approve-list-item" v-for="(item,index) in dataList" :key="index" @click="sendApprove(item)">
                    <div class="content">
                         <span class="name">{{item.templateName}}</span>
                     </div>
                     <div class="bottom">
                         <div class="pre" @click="previewApprove(item)">查看预览</div>
                         <div class="send-approve" @click="sendApprove(item)">发起审批</div>
                     </div>
                </div> -->
                <div class="box">
                   <div class="box-item" v-for="(item,index) in dataList" :key="index"  @click="sendApprove(item)">
                       <div class="opera-btn">
                           <img :src="gateway.yl" alt="审批流预览" title="审批流预览"  @click.stop="previewApprove(item)">
                       </div>
                       <img :src="gateway.lc1" alt="">
                       <p>{{item.templateName}}</p>
                   </div>
                </div>
            </div>
        </div>
        <div v-if="this.mode===2" class="form-entry-list">
            <div class="business-list">
<!--               <div class="business-list-item" v-for="(item,index) in dataList" :key="index">
                    <div class="content">
                       <span class="name">{{item.templateName}}</span>
                    </div>
                    <div class="bottom">
                        <el-badge class="badge-item" v-permission="permission.previewProcessTemplateBtn">
                            <div class="pre" @click="previewProcess(item)">查看预览</div>
                        </el-badge>
                         <div class="flow" @click="previewProcessImg(item)">流程图</div>
                        <el-badge class="badge-item" v-permission="permission.startProcessTemplateBtn">
                           <div class="send-approve" @click="sendProcess(item)">发起流程</div>
                        </el-badge>
                    </div>
               </div> -->
               <div class="box">
                   <div class="box-item" v-for="(item,index) in dataList" :key="index" @click="previewProcessImg(item)">
                       <div class="opera-btn">
                           <img :src="gateway.lct" alt="发起流程" title="发起流程" @click.stop="sendProcess(item)" v-permission="permission.startProcessTemplateBtn">
                           <img :src="gateway.yl" alt="流程预览"  title="流程预览" @click.stop="previewProcess(item)"  v-permission="permission.previewProcessTemplateBtn">
                       </div>
                       <img :src="gateway.lc3" alt="">
                       <p>{{item.templateName}}</p>
                   </div>
               </div>
            </div>
           <!-- <QuickEntryProcess :mode="this.mode"/> -->
        </div>
        <el-dialog class="popAddModelDetail" width="95%" top="1vh" :fullscreen="true" append-to-body :visible.sync="isShowModelDetail" @close="hideDialog">
            <ModelDetail
                ref="modelDetailChild"
                :isShowForm="isShowForm"
                :formInfo="formInfo"
                :isReturnToNav="true"
                @setIsShowForm="setIsShowForm"
                @modelComplete="handleModelComplete"
                @switchMode="handleSwitchFormMode"
            />
        </el-dialog>
        <el-dialog  title="审批人员" :visible.sync="isShowApproveList" append-to-body>
            <div>
               <el-steps :active="approveUserList.length" align-center>
                  <el-step v-for="(item,index) in approveUserList" :key="index"  :title="item.trueName"></el-step>
                </el-steps>
            </div>
        </el-dialog>
        <el-dialog
            :title="approvalTitle"
            width="80%"
            top="0vh"
            append-to-body
            class="approval-pop-dialog"
            :visible.sync="isShowApprovalPop"
            :fullscreen=true
            >
            <ApprovalPop
                    :key="loadTimer"
                    ref="approvalPop"
                    :instances="{id:approvalInstanceId,formObj: {}}"
                    :isInstance="false"
                    :approvalTemplateObj="templateInfo"
                    :busiProcessInstanceId="busiProcessInstanceId"
                    :busiProcessInstanceName="busiProcessInstanceName"
                    :busiTaskInstanceId="busiTaskInstanceId"
                    :belongProcessFlag="belongProcessFlag"
                    :formDataFromBusiness="formInfo"
                    :taskParam="taskParam"
                    :processModelFormsObj="processModelFormsObj"/>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="handleSaveDraft"  type="success">保存草稿</el-button>
                        <el-button @click="handleApply" :loading="startApprovalloading" type="primary">发起审批</el-button>
                        <el-button @click="isShowApprovalPop=false"  type="info">取 消</el-button>
                    </span>
        </el-dialog>
        <el-dialog
            title="流程预览"
            width="80%"
            append-to-body
            :fullscreen=true
            :visible.sync="isShowSetting"
            >
            <ProcessSetting
              :key="loadTimer"
              :processInstance="processInstance"
              :taskList="taskList"
              :archiveTemplateTreeList="archiveTemplateTreeList"
            />
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowSetting=false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 显示详细 -->
        <el-dialog
            title="流程明细"
            :fullscreen=true
            append-to-body
            :visible.sync="isShowDiagram"
            custom-class="diagram-dialog">
            <ProcessDetailView ref="detailView" :viewParams="viewParams" />
        </el-dialog>
        <el-dialog
            class='processPopClass'
            title="启动流程"
            top="0vh"
            width="80%"
            append-to-body
            :visible.sync="isShowStartProcessDialog">
            <ProcessInstancePop :key="loadTimer" ref="processInstancePop" :fromWorkAssistant="true"  @handleClosePop="handleClosePop"/>
        </el-dialog>
    </div>
</template>

<script>
import { getModelFormById, saveAppModelForm, getAllUserTask, getArchiveTemplateTreeList, getApprovalTemplateList, getProcessTemplateList } from '@/data-model';
import { isEmpty } from 'lodash';
import { objectKeyIsEmpty } from '@/utils/grocer';
import ModelDetail from '@/pages/business/BusinessApplication/ModelDetail';
import QuickEntryProcess from './QuickEntryProcess';
import ProcessInstancePop from '@/pages/process/ProcessTemplate/ProcessInstancePop';
import ProcessDetailView from '@/pages/process/ProcessList/ProcessDetailView';
import { CONST_PERMISSION_PROCESS_START_PROCESS_TEMPLATE_BTN,
    CONST_PERMISSION_PROCESS_DESIGN_PROCESS_TEMPLATE_BTN,
    CONST_PERMISSION_PROCESS_PUBLISH_PROCESS_TEMPLATE_BTN,
    CONST_PERMISSION_PROCESS_PREVIEW_PROCESS_TEMPLATE_BTN,
    CONST_PERMISSION_PROCESS_CONFIG_PROCESS_TEMPLATE_BTN
} from '@/common/constants';
export default{
    components: {
        ModelDetail,
        QuickEntryProcess,
        ProcessInstancePop,
        ProcessDetailView
    },
    props: {
        dataList: {
            type: Array
        },
        mode: {
            type: Number,
            default: 0
        },
        chooseDataIds: {
            type: String
        }
    },
    data () {
        return {
            gateway: {
                mxbd_icon: require('@/assets/img/gateway/mxbd_icon.png'),
                more_icon: require('@/assets/img/gateway/more_icon.png'),
                mxbd_icon: require('@/assets/img/gateway/mxbd_icon.png'),
                lc1: require('@/assets/img/gateway/lc1.png'),
                lc2: require('@/assets/img/gateway/lc2.png'),
                lc3: require('@/assets/img/gateway/lc3.png'),
                yl: require('@/assets/img/gateway/yl.png'),
                lct: require('@/assets/img/gateway/lct.png')
            },
            isShowModelDetail: false,
            isShowForm: false,
            formInfo: {},
            selectedModel: {},
            isShowModelFormList: false,
            approveList: [],
            isShowApproveList: false,
            approveUserList: [],
            isShowApprovalPop: false,
            startApprovalloading: false,
            busiProcessInstanceId: '',
            busiProcessInstanceName: '',
            taskParam: {},
            busiTaskInstanceId: '',
            belongProcessFlag: 0,
            processModelFormsObj: [],
            templateInfo: {
                id: '',
                templateName: '',
                busiType: '',
                busiTypeName: '',
                remarks: '',
                selectedUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                templateState: null,
                forms: [],
                users: [],
                approvalList: [[]],
                dataOperate: {
                    dataSource: 2,
                    forms: []
                },
                orderMode: 0,
                rejectMode: 0,
                sendSms: 0,
                clearApprovalUsers: 0,
                durTime: 0,
                warnDate: '',
                selectedCopyUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                approvalMethod: 1, // 审批方法，1:普通审批，2:审批流节点或签审批
                showAllMyApprovals: true
            },
            approvalTitle: '',
            permission: {
                startProcessTemplateBtn: [
                    CONST_PERMISSION_PROCESS_START_PROCESS_TEMPLATE_BTN
                ],
                designProcessTemplateBtn: [
                    CONST_PERMISSION_PROCESS_DESIGN_PROCESS_TEMPLATE_BTN
                ],
                publishProcessTemplateBtn: [
                    CONST_PERMISSION_PROCESS_PUBLISH_PROCESS_TEMPLATE_BTN
                ],
                previewProcessTemplateBtn: [
                    CONST_PERMISSION_PROCESS_PREVIEW_PROCESS_TEMPLATE_BTN
                ],
                configProcessTemplateBtn: [
                    CONST_PERMISSION_PROCESS_CONFIG_PROCESS_TEMPLATE_BTN
                ]
            },
            approvalInstanceId: '',
            loadTimer: '',
            isShowSetting: false,
            taskList: [],
            processInstance: {
                processServiceName: '',
                name: ''
            },
            archiveTemplateTreeList: [],
            viewParams: {},
            isShowDiagram: false,
            isShowStartProcessDialog: false
        };
    },
    created () {
        if (this.mode === 1 && this.chooseDataIds && this.chooseDataIds !== '') {
            this.getApproveTemplateList();
        } else if (this.mode === 2 && this.chooseDataIds && this.chooseDataIds !== '') {
            this.getBusinessTemplateList();
        }
    },
    methods: {
        addFormVal (obj) {
            if (!obj.modelId) { // 用户没有配置自己的快捷方式
                obj.modelId = obj.id;
            }
            this.selectedModel = obj;
            this.selectedModel.state = 1;
            this.selectedModel.fromStore = 1;
            this.handleSwitchFormMode(2);
        },
        async handleSwitchFormMode (mode) {
            this.isShowModelDetail = false;
            this.isShowModelFormList = false;
            if (mode === 1) {
                // 切换到数据列表
                this.renderModelFormList(this.selectedModel);
                this.isShowModelFormList = true;
            } else if (mode === 2) {
                // 切换到表单录入
                this.renderModelDetail(this.selectedModel);
            }
        },
        async renderModelDetail (model) {
            this.modelId = model.modelId;
            this.formInfo = await getModelFormById(model.modelId);
            this.formInfo.modelName = model.modelName;
            this.formInfo.appName = model.appName;
            this.formInfo.remarks = model.remarks;
            this.formInfo.modelType = model.modelType;
            this.isShowModelDetail = true;
            this.setIsShowForm(false);
            setTimeout(() => {
                this.$refs.modelDetailChild.loadFormData(this.formInfo);
            }, 0);
        },
        hideDialog () {
            this.isShowModelDetail = false;
        },
        setIsShowForm (status) {
            this.isShowForm = status;
        },
        async handleModelComplete (model) {
            if (objectKeyIsEmpty(model.forms[0].values, model.forms[0].attributes)) {
                this.$confirm(`表单数据为空，数据将不会保存！`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then((res) => {
                    this.isShowModelDetail = false;
                    this.init_form_entry();
                }).catch(() => {});
            } else {
                model.modelId = this.modelId;
                await saveAppModelForm(this.modelId, model);
                this.isShowModelDetail = false;
            }
        },
        jumpForm (obj) {
            // let modelId = obj.id;
            // localStorage.setItem('defaultAppId', obj.appId);// 进入应用设计时定位打开对应应用
            // var url = '/businessSystem?defaultModelId=' + modelId;
            let modelId = '';
            if (obj.modelId) {
                modelId = obj.modelId;
            } else {
                modelId = obj.id;
            };
            let appI = '';
            if (obj.category == 1) {
                appI = obj.pId;
            } else {
                appI = obj.appId;
            }
            localStorage.setItem('defaultAppId', obj.fAppId);// 进入应用设计时定位打开对应应用
            let url = '/businessSystem';
            if (window.location.href.indexOf('#/') > -1) {
                // 本地访问路径
                // url = '#' + url;
            } else {
                url = '/bpm' + url;
            }
            let param = {appId: appI, modelId: modelId};
            // this.navigateNameTo(url, 'businessSystem', param);
            let routeUrl = this.$router.resolve({
                path: url,
                query: param
            });
            window.open(routeUrl.href, '_blank');
        },
        setFormAuth (modelObj) {
            let currentUserStr = sessionStorage.getItem('currentUserInfo');
            let userInfo = JSON.parse(currentUserStr);
            let userFormAuth = userInfo.modelUserAuthMap[modelObj.formId];
            if (!isEmpty(userFormAuth) && !isEmpty(userFormAuth.modelAuthList)) {
                let authArr = userFormAuth.modelAuthList.split(',');
                let flag = false;
                for (let i = 0; i < authArr.length; i++) {
                    if (authArr[i] === '1') {
                        flag = true;
                    }
                }
                return flag;
            } else {
                return true;
            }
        },
        previewApprove (obj) {
            if (obj.users && obj.users.length > 0) {
                this.approveUserList = obj.users;
                this.isShowApproveList = true;
            } else {
                this.$message({
                    showClose: true,
                    message: '本条模板没有审批人',
                    type: 'error'
                });
            }
        },
        sendApprove (obj) {
            this.approvalTitle = '发起【' + obj.templateName + '】审批申请';
            this.templateInfo = obj;
            this.templateInfo.remarks = '';
            this.templateInfo.selectedUser = {};
            if (!isEmpty(obj.selectedUserIds)) {
                if (obj.clearApprovalUsers) {
                    this.templateInfo.selectedUser.selectedUserIds = '';
                    this.templateInfo.selectedUser.selectedUserNames = '';
                    this.templateInfo.selectedUserIds = '';
                    this.templateInfo.selectedUserNames = '';
                } else {
                    this.templateInfo.selectedUser.selectedUserIds = obj.selectedUserIds;
                    this.templateInfo.selectedUser.selectedUserNames = obj.selectedUserNames;
                }
            } else { // 解决ApprovalPop页面selectedUser.selectedUserNames不能为空的rule提示异常
                this.templateInfo.selectedUser.selectedUserIds = '';
                this.templateInfo.selectedUser.selectedUserNames = '';
            }
            this.loadTimer = new Date().getTime();
            this.approvalInstanceId = this.generateUUID();
            setTimeout(() => { // 默认回显值
                this.$refs.approvalPop._initPage();
            }, 0);
            this.isShowApprovalPop = true;
        },
        generateUUID () {
            var d = new Date().getTime();
            if (window.performance && typeof window.performance.now === 'function') {
                d += window.performance.now(); // use high-precision timer if available
            }
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
            return uuid.replace(RegExp('-', 'g'), '');
        },
        async handleSaveDraft () {
            // opType 操作模式：1 保存草稿 2发起审批
            let isToApproval = this.$refs.approvalPop.isToApproval();
            if (!isToApproval) {
                return;
            }
            let isValid = await this.$refs.approvalPop.handelSaveForms(1);
            if (!isValid) {
                this.isShowApprovalPop = false;
                sessionStorage.setItem('isShowApprovalDraft', true);
                if (this.belongProcessFlag === 0) {
                    this.navMyApprovalApplied();
                } else if (this.belongProcessFlag === 1 || this.belongProcessFlag === 2) {
                    this.$emit('closeApprovalTemplate', {index: '3'});
                }
            }
        },
        async handleApply () {
            setTimeout(() => { // 默认回显值
                let isToApproval = this.$refs.approvalPop.isToApproval();
                if (!isToApproval) {
                    return;
                }
                this.hasApplyUser = this.$refs.approvalPop.hasApplyUser();
                this.$refs.approvalPop.hasRepeatUser();
                if (this.hasApplyUser) {
                    this.$confirm(`审批人中含有申请人,您确定要发起审批吗？`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async (res) => {
                        this.startApprovalloading = true;
                        let isValid = await this.$refs.approvalPop.handelSaveForms(2);
                        if (!isValid) {
                            this.isShowApprovalPop = false;
                            // console.log("============="+this.belongProcessFlag);
                            if (this.belongProcessFlag === 0) {
                                this.navMyApprovalApplied();
                            } else if (this.belongProcessFlag === 1 || this.belongProcessFlag === 2) {
                                this.$emit('closeApprovalTemplate', {index: '0'});
                            }
                        }
                        this.startApprovalloading = false;
                    }).catch(() => {
                    });
                } else {
                    // opType 操作模式：1 保存草稿 2发起审批
                    this.$confirm(`您确定要发起审批吗？`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async (res) => {
                        this.startApprovalloading = true;
                        let isValid = await this.$refs.approvalPop.handelSaveForms(2);
                        if (!isValid) {
                            this.isShowApprovalPop = false;
                            // console.log("============="+this.belongProcessFlag);
                            if (this.belongProcessFlag === 0) {
                                this.navMyApprovalApplied();
                            } else if (this.belongProcessFlag === 1 || this.belongProcessFlag === 2) {
                                this.$emit('closeApprovalTemplate', {index: '0'});
                            }
                        }
                        this.startApprovalloading = false;
                    }).catch(() => {});
                }
            }, 100);
        },
        async previewProcess (process) {
            let tasks = await getAllUserTask(null, process.processServiceId, process.id, process.deploymentId);
            this.taskList = tasks;
            this.processInstance.id = '-1';
            this.processInstance.processServiceId = process.processServiceId;
            this.processInstance.processServiceName = process.processServiceName;
            this.processInstance.name = process.processServiceName;
            this.processInstance.deploymentId = process.deploymentId;
            this.processInstance.processDefinitionId = process.id;
            // console.log(this.processInstance);
            let treeList = [];
            if (process.archiveTemplateId) {
                treeList = await getArchiveTemplateTreeList({templateId: process.archiveTemplateId});
            }
            this.archiveTemplateTreeList = treeList;
            this.loadTimer = new Date().getTime();
            this.isShowSetting = true;
        },
        previewProcessImg (obj) {
            this.viewParams.id = obj.processDefinitionId;
            this.viewParams.pModelId = '';
            this.viewParams.viewDiagram = true;
            this.isShowDiagram = true;
            setTimeout(() => {
                this.$refs.detailView.setProcessState(this.viewParams);
            }, 0);
        },
        sendProcess (process) {
            this.loadTimer = new Date().getTime();
            setTimeout(async () => { // 默认回显值
                await this.$refs.processInstancePop.handleStartProcess(process);
            }, 0);
            this.isShowStartProcessDialog = true;
        },
        handleClosePop () {
            this.isShowStartProcessDialog = false;
        },
        async getApproveTemplateList () {
            this.loading = true;
            let formData = await getApprovalTemplateList(Object.assign({}, {
                currentPage: 0,
                pageSize: '1000'
            }, this.searchParams));
            this.approvalTemplateList = [];
            if (formData.data.length > 0) {
                for (let i = 0; i < formData.data.length; i++) {
                    let cur = formData.data[i];
                    if (this.chooseDataIds.indexOf(cur.id) !== -1) {
                        this.approvalTemplateList.push(cur);
                    }
                }
            }
            // this.approvalTemplateList = formData.data;
            this.page = {
                currentPage: formData.currentPage,
                pageSize: formData.pageSize,
                totalPageNum: formData.totalPageNum
            };
            this.loading = false;
        },
        async getBusinessTemplateList () {
            let { data } = await getProcessTemplateList(this.processSearchParams);
            this.processList = [];
            if (data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    let cur = data[i];
                    if (this.chooseDataIds.indexOf(cur.id) !== -1) {
                        this.processList.push(cur);
                    }
                }
            }
            // this.processList = data;
            this.loadingBusiness = false;
        }
    }
};
</script>

<style lang="less">
    .main-data-quickentry{
        .form-entry-list{
            display: flex;
            flex-wrap: wrap;
            .form-entry-item{
                display: inline-block;
                width: auto;
                height: 60px;
                margin-left: 10px;
                margin-top: 10px;
                cursor: pointer;
                background: #FFFFFF;
                text-align: center;
                line-height: 60px;
                padding: 0px 16px 0px 16px;
                border-radius: 6px;
                border: 1px solid #e8edf1;
                .form-add{
                    font-size: 1.75rem;
                    cursor: pointer;
                    margin-left: 8px;
                }
                .form-add:hover{
                    color:#00bcd4;
                }
            }
            .form-entry-form{
                cursor: pointer;
                margin-left: 20px;
                text-align: center;
                width: 160px;
                height: 120px;
                background: #FFFFFF;
                border: 1px solid #EFF2F5;
                font-size: 16px;
                font-weight: 500;
                color: #252936;
                margin-top: 10px;
                img{
                    margin-top: 20px;
                    // margin-bottom: 16px;
                }
                p{
                    display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
                    -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
                    overflow: hidden; /*超出的文本隐藏*/
                    text-overflow: ellipsis; /* 溢出用省略号*/
                    -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
                    padding: 0 10px;
					// height: 30px;
                }
            }
            .form-entry-item:hover{
                border: 1px solid #00bcd4;
            }
            .approve-list{
               display: flex;
               flex-wrap: wrap;
               overflow-y: auto;
               height: auto;
               padding-bottom: 10px;
               .approve-list-item{
                   width: 12vw;
                   height: 100px;
                   margin-left: 10px;
                   margin-top: 10px;
                   cursor: pointer;
                   background: #FFFFFF;
                   text-align: center;
                   border-radius: 6px;
                   border: 1px solid #e8edf1;
                   .content{
                       display: flex;
                       height: 70px;
                       line-height: 50px;
                       .name{
                           display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
                           -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
                           overflow: hidden; /*超出的文本隐藏*/
                           text-overflow: ellipsis; /* 溢出用省略号*/
                           -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
                           flex: 1;
                           text-align: left;
                           margin-left: 10px;
                       }
                   }
                   .bottom{
                        height: 30px;
                        display: flex;
                        .pre{
                            flex: 1;
                            background-color: #ecf5ff;
                            height: 30px;
                            line-height: 30px;
                            text-align: center;
                            font-size: 12px;
                            color: #409eff;
                        }
                        .send-approve{
                            flex: 1;
                            background-color: #fdf6ec;
                            color: #e6a23c;
                            height: 30px;
                            line-height: 30px;
                            text-align: center;
                            font-size: 12px;
                        }
                        .send-approve:hover{
                            background-color: #ffefd9;
                            border: 1px solid #e6a23c;
                        }
                        .pre:hover{
                            background-color: #d8e8fb;
                            border: 1px solid #409eff;
                        }
                   }
               }
               .box {
                    margin: 0 10px;
                    display: flex;
                    justify-content: wrap;
                    flex-wrap: wrap;
                    // height: 300px;
                    overflow: auto;
                   .box-item {
                      width: 200px;
                      height: 80px;
                      background: #F5F9FF;
                      border-radius: 4px;
                      border: 1px solid #EFF2F5;
                      position: relative;
                      margin-left: 10px;
                      margin-top: 10px;
                      cursor: pointer;
                      .opera-btn{
                          position: absolute;
                          right: 4px;
                          z-index: 333;
                          img{
                              height: 16px;
                              margin-top: 4px;
                              cursor: pointer;
                          }
                          img:hover{
                            width: 40px;
                            height: 40px;
                          }
                      }
                      img {
                           margin-top: 26px;
                           margin-left: 20px;
                           margin-bottom: 18px;
                       }
                       p {
                           margin-left: 20px;
                           font-size: 16px;
                           font-family: PingFangSC-Medium, PingFang SC;
                           font-weight: 500;
                           color: #252936;
                           position: absolute;
                           top: 26px;
                           left: 30px;
                           display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
                           -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
                           overflow: hidden; /*超出的文本隐藏*/
                           text-overflow: ellipsis; /* 溢出用省略号*/
                           -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
                       }
                   }
                }
               .approve-list-item:hover{
                   border: 1px solid #00bcd4;
               }
            }
            .business-list{
               display: flex;
               flex-wrap: wrap;
               overflow-y: auto;
               height: auto;
               padding-bottom: 10px;
               width: 100%;
               .business-list-item{
                   width: 12vw;
                   height: 100px;
                   margin-left: 10px;
                   margin-top: 10px;
                   cursor: pointer;
                   background: #FFFFFF;
                   text-align: center;
                   border-radius: 6px;
                   border: 1px solid #e8edf1;
                   .content{
                       display: flex;
                       height: 70px;
                       line-height: 50px;
                       .name{
                           display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
                           -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
                           overflow: hidden; /*超出的文本隐藏*/
                           text-overflow: ellipsis; /* 溢出用省略号*/
                           -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
                           flex: 1;
                           text-align: left;
                           margin-left: 10px;
                       }
                   }
                   .bottom{
                       height: 30px;
                       display: flex;
                       .badge-item{
                           flex: 1;
                           .pre{
                               flex: 1;
                               background-color: #ecf5ff;
                               height: 30px;
                               line-height: 30px;
                               text-align: center;
                               font-size: 12px;
                               color: #409eff;
                           }
                           .send-approve{
                               flex: 1;
                               background-color: #fdf6ec;
                               color: #e6a23c;
                               height: 30px;
                               line-height: 30px;
                               text-align: center;
                               font-size: 12px;
                           }
                           .send-approve:hover{
                               background-color: #ffefd9;
                               border: 1px solid #e6a23c;
                           }
                           .pre:hover{
                               background-color: #d8e8fb;
                               border: 1px solid #409eff;
                           }
                       }
                       .flow{
                           flex: 1;
                           background-color: #e1feff;
                           color: #0bb7af;
                           height: 30px;
                           line-height: 30px;
                           text-align: center;
                           font-size: 12px;
                       }
                       .flow:hover{
                           flex: 1;
                           background-color: #cbf4f1;
                           color: #00bcd4;
                           border: 1px solid #00bcd4;
                           height: 30px;
                           line-height: 30px;
                           text-align: center;
                           font-size: 12px;
                       }
                   }
               }
               .box {
                    margin: 0 10px;
                    display: flex;
                    justify-content: start;
                    flex-wrap: wrap;
                    // height: 300px;
                    overflow: auto;
                    width: 100%;
                   .box-item {
                      width: 220px;
                      height: 80px;
                      background: #F5F9FF;
                      border-radius: 4px;
                      border: 1px solid #EFF2F5;
                      position: relative;
                      margin-left: 10px;
                      margin-top: 10px;
                      cursor: pointer;
                      .opera-btn{
                          position: absolute;
                          right: 4px;
                          z-index: 333;
                          img{
                              margin-top: 4px;
                              margin-left: 0px;
                              cursor: pointer;
                          }
                          img:hover{
                            width: 40px;
                            height: 40px;
                          }
                      }
                       img {
                           margin-top: 24px;
                           margin-left: 20px;
                           margin-bottom: 18px;
                       }
                       p {
                           margin-left: 20px;
                           font-size: 16px;
                           font-family: PingFangSC-Medium, PingFang SC;
                           font-weight: 500;
                           color: #252936;
                           position: absolute;
                           top: 26px;
                           left: 34px;
                           display: -webkit-box;
                           -webkit-line-clamp: 1;
                           overflow: hidden;
                           text-overflow: ellipsis;
                           -webkit-box-orient: vertical;
                       }
                   }
               }

               .business-list-item:hover{
                    border: 1px solid #00bcd4;
               }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/DataWarehousing/QuickEntry.vue